<div>
    <div class="right-align bil-right-margin-5 bil-top-margin-5 bil-bottom-padding-20 bil-pointer-class">
        <img src="../../assets/images/smallclose.svg" (click)="close()" />
    </div>
    <div class="left-spacing">
        <span class="bil-font-regular bil-font-weight">
            Learn How to Download
        </span>
    </div>
    <div class="left-spacing">
        <span class=" bil-font-regular bil-font-weight">
            Bank Statement ?
        </span>
    </div>
    <div class="spacing">
        <div class="bil-font-blue bil-font-xmedium">
            <div class="bil-display-flex">
                <span class="rectangle">1</span>
                <div class="bil-left-padding-10">
                    Login to your Net Banking Portal
                </div>
            </div>
        </div>
    </div>
    <div class="spacing">
        <div class="bil-font-blue bil-font-xmedium">
            <div class="bil-display-flex">
                <span class="rectangle">2</span>
                <div class="bil-left-padding-10">
                    Look for Account Statement
                </div>
            </div>
        </div>
    </div>
    <div class="spacing">
        <div class="bil-font-blue bil-font-xmedium">
            <div class="bil-display-flex">
                <span class="rectangle">3</span>
                <div class="bil-left-padding-10">
                    Select the time period and choose
                    <div>
                        from pdf format
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="spacing">
        <div class="bil-font-blue bil-font-xmedium">
            <div class="bil-display-flex">
                <span class="rectangle">4</span>
                <div class="bil-left-padding-10">
                    Click on the download button
                </div>
            </div>
        </div>
    </div>
</div>